export default {
  data() {
    return {
      user_id: null,
      user: null,
      users: null,
      fulldb: null,
      auth_ready: false,
      accounts: {},
      box_accounts: {},
      ideas: {},
      idea_boxes: {},
    }
  },
  computed: {
    box_account_id() {
      return this.$route.query.box_account_id
    },
    active_box_account() {
      return this.$root.box_accounts[this.box_account_id]
    },
    admin() {
      // return false
      const admin = this.user && this.user.role === 'admin'
      return admin
    },
    community_manager() {
      return this.user && this.user.role === 'community_manager'
    },
    permissions() {
      if (!this.user) return []
      const permissions = []
      if (this.user.role === 'admin' || this.user.role === 'community_manager' || this.user.role === 'client') permissions.push('confirm')
      if (this.user.role === 'admin' || this.user.role === 'community_manager') {
        permissions.push('archive')
        permissions.push('publish')
        permissions.push('manage')
      }

      return permissions
    }
  },
  methods: {
    change_notification(user_id) {
      firebase.database().ref('/' + (localStorage.ENV || 'prod') + '/users/' + user_id + '/notification')
            .once('value')
            .then(snapshot => {
              const notification = snapshot.val()
              set(`users.${user_id}.timestamp`, new Date().getTime())
              return set(`users.${user_id}.notification`, !notification)
            })
    },
    change_user_lang(user_id) {
      firebase.database().ref('/' + (localStorage.ENV || 'prod') + '/users/' + user_id + '/lang')
            .once('value')
            .then(snapshot => {
              const lang = snapshot.val() || 'fr'
              return set(`users.${user_id}.lang`, (lang === 'fr') ? 'en' : 'fr')
            })
    },
    add_box_account() {
      const id = 'box_account_' + new Date().getTime() + (''+Math.floor(Math.random() * 1000)).padLeft(4,'0')
      const data = { id }
      this.$root.admin_modal = {name:'box_account', data}
    },
    disable_account(box_account_id, disable=true) {
      return set(`public.accounts.${box_account_id}.disabled`, disable)
    },
    delete_box_account(box_account_id) {
      const conf = confirm("Etes vous sûr ? Cette action est irréversible")
      if (!conf) return
      return set(`public.box_accounts.${box_account_id}`, null)
        .then(() => {
          update_query({box_account_id: this.$root.accounts.keys().first()})
          this.$root.admin_modal = null
        })
    },
    new_box_account(data) {
      // const logo = this.$root.box_accounts[data.id] && this.$root.box_accounts[data.id].logo || ''
      set(`public.box_accounts.${data.id}`, data.filter((v,k) => k !== 'users'))
            .then(() => {
                if (!data.users) return
                data.users.map(uid => {
                  set(`users.${uid}.box_accounts.${data.id}`,true)
                })
            })
            .then(() => this.$root.admin_modal = null)
    },
    logo_upload(ev, box_account_id) {
      const file = ev.target.files[0];
      const path = `public/logos/${box_account_id}/${file.name}`
      const ref = firebase.storage().ref().child(path)
      this.$root.uploading = true
      const instance = this
      return ref.put(file).then(function(snapshot) {
        instance.$root.uploading = false
        return path
      })
    },
    login_email(email, password) {
      return firebase.auth().signInWithEmailAndPassword(email, password)
        .then((credentials) => this.bind_user(credentials.user))
    },
    logout() {
      firebase.auth().signOut()
    },
    check_route(route) {
      const authenticated = !!this.user
      const authorized = route.path === '/login' || authenticated
      return authorized
    },
    bind_user(user) {
      localStorage.setItem('uid',user.uid)
      this.$root.user_id = user.uid
      this.$bindAsObject(
            'user',
            firebase.database().ref((localStorage.ENV || 'prod') + '/users/' + user.uid),
            null,
            () => {
              this.$root.lang = this.user.lang || 'fr'
              if (this.user.role === 'admin') {
                bind_key(this, 'ideas','public/ideas')
                bind_key(this, 'idea_boxes','public/idea_boxes')
                bind_key(this, 'box_accounts','public/box_accounts')
                this.$bindAsObject('accounts',firebase.database().ref((localStorage.ENV || 'prod') + '/public/accounts'), null, () => delete this.accounts['.key'])
                return
              }
              (this.user.accounts || {}).keys().map(account_id => {
                bind_key(this.accounts, account_id, 'public/accounts/' + account_id)
              })
              this.user.box_accounts.keys().map(box_account_id => {
                console.log('binding', box_account_id)
                bind_key(this.box_accounts, box_account_id, 'public/box_accounts/' + box_account_id)
                bind_key(this.ideas, box_account_id, 'public/ideas/' + box_account_id)
                bind_key(this.idea_boxes, box_account_id, 'public/idea_boxes/' + box_account_id)
              })
            })
      this.auth_ready = true
    },
    new_user(data) {
      if (!data.role) data.role = 'client'
      if (!data.lang) data.lang = 'fr'
      console.log('b',data)
      return axios.get('https://us-central1-lbc-calendar.cloudfunctions.net/user', {params: data})
              .then(res => {
                const uid = res.data.uid
                return set('users.'+uid, data.filter((v,k) => k !== 'password'))
              })
    },
    edit_user(data) {
      const base = this.$root.users[data.id]
      return set('users.'+data.id, Object.assign(base, data.filter((v,k) => k !== 'id')))
    },
    delete_user(uid) {
      return axios.get('https://us-central1-lbc-calendar.cloudfunctions.net/delete_user?uid=' + uid)
              .then(res => {
                return set('users.'+uid, null)
              })
    },
  },
  watch: {
    ideas() {
      if (!this.$route.query.idea_id || this.$root.modal) return
      if (this.ideas && this.ideas[this.$root.box_account_id] && this.ideas[this.$root.box_account_id][this.$route.query.idea_id]){
        const idea = this.ideas[this.$root.box_account_id][ this.$route.query.idea_id]
        this.$root.current = new Date(idea.date)
        this.$root.modal = {idea_id: idea.id}
      }
    },
    '$root.box_accounts': {
      handler() {
        if (!this.$route) return
        if (this.$root.box_accounts && !this.$route.query.box_account_id) this.$router.push({ query: {box_account_id: this.$root.box_accounts.keys().first()}})
      }, immediate: true
    },
    user() {
      if (['admin','community_manager'].includes(this.user.role) && !this.users) this.bind_key(this, 'users', 'users')
    }
  }
}
